//apollo.js
// uri: `https://renards.aloha.studio/graphql`,

import { ApolloClient, InMemoryCache } from "@apollo/client";
const client = new ApolloClient({
	uri: `https://cierenards.be/graphql`,
	cache: new InMemoryCache(),
});
export default client;
